<p>{{signalS.variable$()}}</p>

<p>{{variable()}}</p>

